import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./ArticleDetail.css";

const ArticleDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Load blog from localStorage
    const savedBlogs = localStorage.getItem("blogs");
    if (savedBlogs) {
      const blogs = JSON.parse(savedBlogs);
      const foundBlog = blogs.find(b => b.id === parseInt(id));
      if (foundBlog) {
        setBlog(foundBlog);
      } else {
        // If blog not found, redirect to articles
        navigate("/articles");
      }
    }
    setLoading(false);
  }, [id, navigate]);

  if (loading) {
    return (
      <div className="article-detail-loading">
        <div className="loader"></div>
        <p>Loading article...</p>
      </div>
    );
  }

  if (!blog) {
    return (
      <div className="article-detail-error">
        <h2>Article not found</h2>
        <button onClick={() => navigate("/articles")} className="back-btn">
          ← Back to Articles
        </button>
      </div>
    );
  }

  return (
    <div className="article-detail-page">
      <div className="container">
        {/* Back Button */}
        <button onClick={() => navigate("/articles")} className="back-btn">
          ← Back to Articles
        </button>

        {/* Article Header */}
        <div className="article-detail-header">
          <span className="article-detail-category">{blog.category}</span>
          <h1 className="article-detail-title">{blog.title}</h1>
          <div className="article-detail-meta">
            <span className="article-detail-author">✍️ {blog.author}</span>
            <span className="article-detail-date">📅 {blog.date}</span>
          </div>
        </div>

        {/* Featured Image */}
        {blog.image && (
          <div className="article-detail-image">
            <img src={blog.image} alt={blog.title} />
          </div>
        )}

        {/* Article Content */}
        <div className="article-detail-content">
          <h2>Introduction</h2>
          <p>{blog.content}</p>
          
          {/* You can add more sections here */}
          <h3>Key Takeaways</h3>
          <ul>
            <li>Understanding the fundamentals of {blog.category}</li>
            <li>Practical applications in trading</li>
            <li>Expert insights from {blog.author}</li>
          </ul>

          <div className="article-detail-share">
            <h4>Share this article</h4>
            <div className="share-buttons">
              <button className="share-btn facebook">📘 Facebook</button>
              <button className="share-btn twitter">🐦 Twitter</button>
              <button className="share-btn linkedin">🔗 LinkedIn</button>
            </div>
          </div>
        </div>

        {/* Related Articles */}
        <div className="related-articles">
          <h3>Related Articles</h3>
          <div className="related-grid">
            <div className="related-card">
              <h4>More Trading Insights</h4>
              <p>Explore our collection of trading articles</p>
              <button onClick={() => navigate("/articles")} className="related-btn">
                View All Articles →
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArticleDetail;